import React from 'react';
import '../App.css';

function ErrorPage() {
    const errorMessage = localStorage.getItem('externalerrormsg') || "An unknown error occurred.";

    return (
        <div className='errormessage'> {errorMessage} </div>
    
    
    );
}
export default ErrorPage;
